import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import HomeServicesIndustry from "@/pages/industries/HomeServicesIndustry";
export const Route = createFileRoute("/industries/home-services")({ head: ({match}) => pageHead(match.pathname), component: () => (<HomeServicesIndustry />) });
